var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExpandMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "expand_more_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#expand_more_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  d: "M8.002 9.968a.738.738 0 0 1-.25-.041.585.585 0 0 1-.217-.142L4.468 6.718a.632.632 0 0 1-.183-.466c0-.19.061-.345.183-.467a.632.632 0 0 1 .467-.183c.19 0 .345.06.467.183l2.6 2.6 2.6-2.6a.632.632 0 0 1 .466-.183c.19 0 .345.06.467.183a.632.632 0 0 1 .184.467.632.632 0 0 1-.184.466L8.468 9.785a.585.585 0 0 1-.216.142.738.738 0 0 1-.25.041Z"
}))));
export default SvgExpandMore;